<rt-assistant-list-card>
  <div class="layout">
    <rt-icon-container
      class="leading"
      shape="squircle"
      containerSize="large"
      size="small"
      name="nav-talent-pools-outline"
      color="colorIconDefault"
      background="colorBgNeutralDefault"
    />
    <div class="text">
      <span class="title">{{ data().title }}</span>
      @if (data().candidatesCount !== undefined) {
        <span class="meta">{{ data().candidatesCount }} candidates</span>
      }
    </div>
  </div>
</rt-assistant-list-card>
